'use strict';

angular.module('cloudBillingLegacyFrontend').controller('CcAddGcpContractPrepareCtrl', function ($scope, $state) {

  $scope.next = function()
  {
    $state.go('authorized.teams.contracts.add-gcp.connect');
  };
});
